import { getDefaultArrayIFace } from '../def'

// import React from 'react'

interface ArrayIFace {
  getNodes?: (resData: unknown) => unknown[]
  getMoreCursor?: (resData: unknown, lastItem: unknown) => unknown
  getTotalCount?: (resData: unknown) => number
  getArgument?: (vars: Record<string, unknown>, key: string, defaultVal?: unknown) => unknown
  setArgument?: (vars: Record<string, unknown>, key: string, val: unknown) => void
  [key: string]: unknown
}

export class ResultObjBase {
  arrayIFace: ArrayIFace | null = null
  dataObj: Record<string, unknown>
  gqlopt: Record<string, unknown>
  tableInfo: Record<string, unknown>

  constructor(gqlopt: Record<string, unknown>) {
    this.gqlopt = gqlopt
    if (gqlopt != null && gqlopt.arrayIFace != null) {
      this.arrayIFace = gqlopt.arrayIFace as ArrayIFace
    }
    this.dataObj = {}

    if (this.arrayIFace == null) {
      if (getDefaultArrayIFace != null) {
        this.arrayIFace = getDefaultArrayIFace() as ArrayIFace
      }
    }
  }

  getArgument = (vars: Record<string, unknown>, key: string, defaultVal: unknown = null) => {
    if (this.arrayIFace != null) {
      if (this.arrayIFace.getArgument != null) {
        return this.arrayIFace.getArgument(vars, key, defaultVal)
      }
    }
    if (vars != null) {
      return vars[key]
    }
    return defaultVal
  }

  setArgument = (vars: Record<string, unknown>, key: string, val: unknown) => {
    if (this.arrayIFace != null) {
      if (this.arrayIFace.setArgument != null) {
        this.arrayIFace.setArgument(vars, key, val)
        return
      }
    }
    vars[key] = val
  }

  getUIObj() {
    return this.dataObj
  }

  setUIObj(value: Record<string, unknown>, _updateUI: boolean = false) {
    this.dataObj = value
  }

  clearUIObj(_updateUI: boolean) {
    this.setUIObj({})
  }

  setLoading(_value: unknown, _updateUI: boolean = false) {}

  getLoading() {
    return false
  }
}

export class ResultObjBaseWithReactObj extends ResultObjBase {
  reactObj: Record<string, unknown> | null = null

  _isStateWaiting: boolean
  _isNeedRefresh: boolean

  name: string
  pageParamName: string
  loadingStateInfo: { name: string | null; enabled: boolean }

  constructor(reactObj: Record<string, unknown> | null, gqlopt: Record<string, unknown>) {
    super(gqlopt)

    this.reactObj = reactObj

    this._isStateWaiting = false
    this._isNeedRefresh = false

    this.name = this.gqlopt.name as string

    if (this.gqlopt.pageParamName) {
      this.pageParamName = this.gqlopt.pageParamName as string
    }
    if (this.gqlopt.tableInfo) {
      this.tableInfo = this.gqlopt.tableInfo as Record<string, unknown>
      // initTableColumeCSS(reactObj, this.tableInfo)
    }

    this.loadingStateInfo = {
      name: null,
      enabled: true,
    }

    this.initReact()
  }

  initReact = () => {
    if (this.reactObj == null) {
      return
    }

    const { reactObj } = this
    reactObj._isNgqlComponent = true

    if (reactObj.state == null) {
      reactObj.state = {}
    }

    if ((reactObj.state as Record<string, unknown>)._ngqlMap == null) {
      ;(reactObj.state as Record<string, unknown>)._ngqlMap = {}
    }

    reactObj.isNgqlComponent = () => {
      return reactObj._isNgqlComponent
    }

    reactObj._applythis = (nobj, value) => {
      if (
        (
          reactObj.updater as Record<string, unknown> as { isMounted: (obj: unknown) => boolean }
        ).isMounted(reactObj) === true
      ) {
        const key = (nobj as { getName: () => string }).getName()

        const newNgqlMap = {
          ...((reactObj.state as Record<string, unknown>)._ngqlMap as Record<string, unknown>),
        }

        newNgqlMap[key] = {
          ...(value as Record<string, unknown>),
        }
        ;(
          reactObj as Record<string, unknown> as {
            setState: (state: Record<string, unknown>) => void
          }
        ).setState({
          _ngqlMap: newNgqlMap,
        })
      }
    }
  }

  getName = () => {
    const { reactObj } = this
    if (this.name == null) {
      let key = `nobj${Date.now()}`
      let idx = 0
      while (
        (
          reactObj as Record<string, unknown> as Record<string, (...args: unknown[]) => unknown>
        ).getthisect(key) !== undefined
      ) {
        key = `nobj${Date.now()}_${idx}`
        idx += 1
      }
      ;((reactObj as Record<string, unknown>).state as Record<string, unknown>)._ngqlMap[key] = null
      this.name = key
    }
    return this.name
  }

  getLoadingName = () => {
    if (this.loadingStateInfo.name == null) {
      if (
        this.gqlopt != null &&
        this.gqlopt.uiInfo != null &&
        (this.gqlopt.uiInfo as Record<string, unknown>).loadingStateName != null
      ) {
        this.loadingStateInfo.name = (this.gqlopt.uiInfo as Record<string, unknown>)
          .loadingStateName as string
      } else {
        this.loadingStateInfo.name = `loading`
      }
    }
    return this.loadingStateInfo.name
  }

  setLoadingName = (name) => {
    this.loadingStateInfo.name = name
  }

  isLoadingStateEnabled = () => {
    let ret: unknown = this.loadingStateInfo.enabled
    if (
      this.gqlopt != null &&
      this.gqlopt.uiInfo != null &&
      (this.gqlopt.uiInfo as Record<string, unknown>).useLoadingState != null
    ) {
      ret = (this.gqlopt.uiInfo as Record<string, unknown>).useLoadingState
    } else if (this.gqlopt != null && this.gqlopt.useLoadingUI != null) {
      ret = this.gqlopt.useLoadingUI !== false
    }
    return ret
  }

  setUIObj(value: Record<string, unknown>, updateUI: boolean = false) {
    if (this.reactObj != null) {
      const { reactObj } = this

      // reactObj.setthisect(key, value, updateUI)
      const newValue = {
        ...this.dataObj,
        ...value,
      }

      this.dataObj = newValue

      if (updateUI !== false) {
        ;(reactObj._applythis as (...args: unknown[]) => void)(this, newValue)
      }
    } else {
      super.setUIObj(value, updateUI)
    }
  }

  clearUIObj(updateUI) {
    this.setUIObj({}, updateUI)
  }

  setLoading(value: unknown, updateUI: boolean = false) {
    if (this.reactObj != null) {
      const loadingName = this.getLoadingName()
      const useLoadingState = this.isLoadingStateEnabled()

      if (useLoadingState !== false && this.reactObj != null) {
        const prevState = this.getUIObj()
        if (prevState[loadingName] !== value) {
          const state = {}
          state[loadingName] = value

          this.setUIObj(state, updateUI)
        }
      }
    }
  }

  getLoading() {
    if (this.reactObj != null) {
      const loadingName = this.getLoadingName()
      const useLoadingState = this.isLoadingStateEnabled()
      if (useLoadingState !== false) {
        const prevState = this.getUIObj()
        return prevState[loadingName] as boolean
      }
    }
    return super.getLoading()
  }
}

export default {
  ResultObjBase,
  ResultObjBaseWithReactObj,
}
